const swiperEvents = new Swiper('.swiper-events', {
  loop: true,
  lazy: true,
  slidesPerView: 1,
  spaceBetween: 10,
  keyboard: {
    enabled: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-events',
    prevEl: '.swiper-button-prev-events',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    }
  }
});

async function openGallery(galleryId) {
    const spinner = document.getElementById('spinner_modal');

    document.getElementById('body').style.overflowY = 'hidden';
    document.getElementById('modal').classList.add('gallery-overlay--active');

    spinner.classList.add('gallery-spinner--active');

    const response = await fetch('/gallery/' + galleryId + '/', {method: 'GET'});

    await sleep(500);

    if (response.ok) {
        document.getElementById('modal_container').innerHTML = await response.text();
        const swiper = new Swiper(
            '.swiper',
            {
                loop: true,
                lazy: true,
                slidesPerView: "auto",
                spaceBetween: 30,
                centeredSlides: true,
                keyboard: {
                    enabled: true,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            }
        );
    } else {
        console.error(response);
    }

    spinner.classList.remove('gallery-spinner--active');
}

function closeGallery() {
    document.getElementById('body').style.overflowY = 'auto';
    document.getElementById('modal').classList.remove('gallery-overlay--active');
    document.getElementById('modal_container').innerHTML = '';
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function scrollToTarget(target) {
    document.getElementById(target).scrollIntoView({block: 'start', behavior: 'smooth'});
}

function activateAbility(bullet) {
    const active_ability_cls = 'abilities-item--active';
    const active_bullet_cls = 'abilities-bullets-item--active';

    Array.from(document.getElementsByClassName(active_ability_cls)).forEach(function (element) {
        element.classList.remove(active_ability_cls);
    });
    document.getElementById('abilities-item-' + bullet.dataset.ability).classList.add(active_ability_cls);

    Array.from(document.getElementsByClassName(active_bullet_cls)).forEach(function (element) {
        element.classList.remove(active_bullet_cls);
    });
    bullet.classList.add(active_bullet_cls);
}

async function submitForm(event) {
    const form = document.getElementById('form');
    const data = new FormData(form);
    const spinner = document.getElementById('spinner');

    if (form.checkValidity() === true) {
        spinner.classList.add('form-left-spinner--active');
        event.preventDefault();

        const response = await fetch(form.action, {method: 'POST', body: data});
        await sleep(2000);

        if (response.ok) {
            document.getElementById('form-success').classList.add('form-left-success--active');
        } else if (response.status === 400) {
            console.error(await response.json());
        } else {
            console.error(response);
        }

        spinner.classList.remove('form-left-spinner--active');
    }
}

function initScrollToTop() {
    const scrollToTopButton = document.getElementById('scroll_to_top');
    const activeScrollToTopButtonClass = 'scroll_to_top--active';
    const border = 700;

    scrollToTopButton.addEventListener('click', () => {
        scrollToTarget('body');
    });

    function toggleScrollToTopButton() {
        if (window.scrollY > border) {
            scrollToTopButton.classList.add(activeScrollToTopButtonClass);
        } else {
            scrollToTopButton.classList.remove(activeScrollToTopButtonClass);
        }
    }

    function throttle(callback, delay) {
        let timerId;
        return function (...args) {
            if (timerId) return;
            timerId = setTimeout(() => {
                callback.apply(this, args);
                timerId = null;
            }, delay);
        };
    }

    toggleScrollToTopButton();

    const throttledScrollHandler = throttle(toggleScrollToTopButton, 200);

    window.addEventListener('scroll', throttledScrollHandler);
}

function initPhoneMask() {
    document.querySelectorAll('.masked').forEach(function (element) {
        const mask = IMask(element, {mask: '+{7} (000) 000-00-00'});

        element.addEventListener('focus', () => {
            if (mask.value === '') {
                mask.value = '+7 (';
            }
        });

        element.addEventListener('blur', () => {
            if (mask.value === '+7 (') {
                mask.value = '';
            }
        });
    });
}

function getObserver(className) {
    return new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting && !entry.target.classList.contains(className)) {
                entry.target.classList.add(className);
            }
        });
    });
}

// function hideEvents() {
//     document.querySelectorAll('.event-wrapper').forEach((element, index) => {
//         if (index >= 3) {
//             element.classList.add('event-wrapper--hidden');
//         }
//     });
// }

document.addEventListener('DOMContentLoaded', () => {

    // document.getElementById('show-more').addEventListener('click', function () {
    //     this.classList.add('show-more--hidden');
    //     document.querySelectorAll('.event-wrapper').forEach(function (element) {
    //         element.classList.remove('event-wrapper--hidden');
    //     });
    // });

    document.querySelectorAll('.header-navigation-item').forEach(function (element) {
        element.addEventListener('click', function () {
            scrollToTarget(element.dataset.target);
        });
    });

    document.querySelectorAll('.main-discuss-button').forEach(function (element) {
        element.addEventListener('click', function () {
            scrollToTarget('form-section');
        });
    });

    document.querySelectorAll('.order-button').forEach(function (element) {
        element.addEventListener('click', function () {
            scrollToTarget('form-section');
        });
    });

    document.querySelectorAll('.ability-button').forEach(function (element) {
        element.addEventListener('click', function () {
            activateAbility(element);
        });
    });

    document.getElementById('form-button').addEventListener('click', async (event) => {
        await submitForm(event);
    });

    initPhoneMask();

    if (window.innerWidth >= 1280) {
        initScrollToTop();
    }
    // if (window.innerWidth < 768) {
    //     hideEvents();
    // }

    let observer_for_left_headings = getObserver('heading-arrow--left-animated');
    let observer_for_right_headings = getObserver('heading-arrow--right-animated');

    document.querySelectorAll('.heading-arrow').forEach(function (element) {
        if (element.classList.contains('heading-arrow--left')) {
            observer_for_left_headings.observe(element);
        } else if (element.classList.contains('heading-arrow--right')) {
            observer_for_right_headings.observe(element);
        }
    });

    document.querySelectorAll('.iceberg-wordlist-item').forEach(function (element, index) {
        setTimeout(function () {
            element.classList.add('iceberg-wordlist-item--animated');
        }, (index + 1) * 1000); // Delay increases by 1 second for each element
    });

    document.querySelectorAll('.event-item-hint').forEach(function (element) {
        element.addEventListener('click', async () => {
            await openGallery(element.dataset.gallery);
        });
    });

    document.getElementById('close_modal').addEventListener('click', function () {
       closeGallery();
    });
});
